import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import Hospitals from "./pages/Hospitals";
import "./App.css";
import { AuthProvider } from "./auth/AuthContext";
import { Login } from "./pages/Login";
import { ProtectedRoute } from "./auth/ProtectedRoute";
import Hospital from "./pages/Hospital";
import Users from "./pages/Users";
import User from "./pages/User";
import BedRequests from "./pages/BedRequests";
import BedRequest from "./pages/BedRequest";

function App() {
  return (
    <Router>
      <div className="App">
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: "#363636",
              color: "#fff",
            },
            success: {
              duration: 3000,
              iconTheme: {
                primary: "#10b981",
                secondary: "#fff",
              },
            },
            error: {
              duration: 4000,
              iconTheme: {
                primary: "#ef4444",
                secondary: "#fff",
              },
            },
          }}
        />
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route
                index
                element={
                  <ProtectedRoute allowedRoles={["superadmin"]}>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />

              {/** Superadmin: see list, hospital_admin can also access this route if you want */}
              <Route
                path="hospitals"
                element={
                  <ProtectedRoute allowedRoles={["superadmin", "hospital_admin"]}>
                    <Hospitals />
                  </ProtectedRoute>
                }
              />

              {/** Hospital detail: both roles can view, but requireHospitalMatch prevents hospital_admin from other hospitals */}
              <Route
                path="hospitals/:id"
                element={
                  <ProtectedRoute
                    allowedRoles={["superadmin", "hospital_admin"]}
                    requireHospitalMatch
                  >
                    <Hospital />
                  </ProtectedRoute>
                }
              />

              <Route
                path="users"
                element={
                  <ProtectedRoute allowedRoles={["superadmin", "hospital_admin"]}>
                    <Users />
                  </ProtectedRoute>
                }
              />
              <Route
                path="users/:id"
                element={
                  <ProtectedRoute
                    allowedRoles={["superadmin", "hospital_admin"]}
                    requireHospitalMatch
                  >
                    <User />
                  </ProtectedRoute>
                }
              />
              {/* <Route
                path="patients"
                element={<div>Patients Page (Coming Soon)</div>}
              /> */}
              <Route
                path="bed-requests"
                element={
                  <ProtectedRoute
                    allowedRoles={["superadmin", "hospital_admin"]}
                  >
                    <BedRequests />
                  </ProtectedRoute>
                }
              />
              <Route
                path="bed-requests/:id"
                element={
                  <ProtectedRoute
                    allowedRoles={["superadmin", "hospital_admin"]}
                  >
                    <BedRequest />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route
              path="*"
              element={
                <div style={{ padding: "2rem", textAlign: "center" }}>
                  <h1>404 - Page Not Found</h1>
                  <p>
                    The page you're looking for doesn't exist or you don't have
                    permission to view it.
                  </p>
                </div>
              }
            />
          </Routes>
        </AuthProvider>
      </div>
    </Router>
  );
}

export default App;
